import type {
  KlardatenInstance,
  KlardatenProfile,
} from '../../api/klardaten-credentials';

function asString(value: unknown): string | null {
  return typeof value === 'string' && value.trim() ? value.trim() : null;
}

export function getNextInstanceDefault(
  instances: KlardatenInstance[],
  currentInstanceId: string | null | undefined
): string | null | undefined {
  if (instances.length === 1) {
    const onlyId = asString(instances[0]?.id);
    if (onlyId && currentInstanceId !== onlyId) {
      return onlyId;
    }
  } else if (
    currentInstanceId &&
    !instances.some((instance) => instance.id === currentInstanceId)
  ) {
    return null;
  }

  return undefined;
}

export function getNextProfileDefault(
  profiles: KlardatenProfile[],
  currentProfileId: string | null | undefined
): string | null | undefined {
  const currentProfileAvailable = profiles.some(
    (profile) => profile.profile_id === currentProfileId
  );
  const autoProfile =
    profiles.find((profile) => profile.is_default) ??
    (profiles.length === 1 ? profiles[0] : undefined);
  const autoProfileId = autoProfile?.profile_id ?? null;

  if (currentProfileId && !currentProfileAvailable) {
    return autoProfileId;
  }
  if (!currentProfileId && autoProfileId) {
    return autoProfileId;
  }

  return undefined;
}
